import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import {scrollToElement} from "@/Helpers/Function";
import Slider from "react-slick";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import '@/Pages/Collections/scss/ocean.scss';

class OceanDesktop extends React.Component {
    constructor(props) {
        super(props);
        this.slider = React.createRef();
    }

    componentDidMount() {
        window.addEventListener('wheel', event => this.mouseWheelHandlerWindow(event));
        this.slider.innerSlider.list.addEventListener('wheel', event => this.mouseWheelHandlerSlider(event));
    }

    componentWillUnmount() {
        window.removeEventListener('wheel', event => this.mouseWheelHandlerWindow(event));
        this.slider.innerSlider.list.removeEventListener('wheel', event => this.mouseWheelHandlerSlider(event));
    }

    mouseWheelHandlerWindow = (event) => {
        if (this.slider === null) return false;
        const options = {block: "center", inline: "center", behavior: "smooth"};
        if (event.deltaY > 0 && this.slider.innerSlider.state.currentSlide + 1 !== this.slider.innerSlider.state.slideCount) {
            scrollToElement(this.slider.innerSlider.list, options);
        }
        if (event.deltaY < 0 && this.slider.innerSlider.state.currentSlide !== 0) {
            scrollToElement(this.slider.innerSlider.list, options);
        }
    }

    mouseWheelHandlerSlider = (event) => {
        if (this.slider === null) return false;
        if (event.deltaY > 0 && this.slider.innerSlider.state.currentSlide + 1 !== this.slider.innerSlider.state.slideCount) {
            event.preventDefault();
            this.slider.slickNext();
        } else if (event.deltaY < 0 && this.slider.innerSlider.state.currentSlide !== 0) {
            event.preventDefault();
            this.slider.slickPrev();
        }
    }

    render() {
        const ArrowLeft = (props) => (
            <Svg id={`arrows-left`} className={`arrows-ocean arrows-ocean__left`} onClick={props.onClick} />
        );

        const ArrowRight = (props) => (
            <Svg id={`arrows-right`} className={`arrows-ocean arrows-ocean__right`} onClick={props.onClick} />
        );

        const settings = {
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            className: "slickOcean",
            vertical: true,
            verticalSwiping: true,
            dots: true,
            dotsClass: "slick-dots-ocean",
            arrows: false,
            prevArrow: <ArrowLeft />,
            nextArrow: <ArrowRight />,
            appendDots: dots => (
                <ul> {dots} </ul>
            ),
            customPaging: () => (
                <span></span>
            ),
        };

        return <div className={`oceanPanel`}>
            <Slider ref={slider => (this.slider = slider)} {...settings}>
                <div className={`oceanPanel__one bg`}>
                    <div className={`content`}>
                        <h1 className={`h1 h1__ocean`}>ОКЕАН</h1>
                        <Link href={`/catalog/okean`} className={`btn btn__ocean`}>
                            Коллекция серебряных украшений
                        </Link>
                        <p className={`inOcean`}>Погрузиться в океан</p>
                        <img className={`arrow-bottom`}
                             src={`/storage/img/collections/cosmos/arrow-2.png`}
                             alt={`Погрузиться в океан`}
                             title={`Погрузиться в океан`}
                        />
                    </div>
                </div>
                <div className={`oceanPanel__two bg`}>
                    <div className={`content`}>
                        <img className={`medusaLeft`}
                             src={`/storage/img/collections/ocean/medusaLeft.png`}
                             alt={`image`}
                             title={`image`}
                        />
                        <p className={`textTop`}>
                            Вот&nbsp;бы &laquo;пляжное&raquo; настроение оставалось с&nbsp;нами как можно
                            дольше!
                            Чтобы яркое солнце, чистое небо и&nbsp;берег океана всегда были рядом...
                        </p>
                        <div
                            className={`medusaCenter cp`}
                            // onClick={() => quickViewStore.openModal('04-0255-00-203-0200-69')}
                        >
                            <img src={`/storage/img/collections/ocean/medusaCenter.png`}
                                 alt={`image`}
                                 title={`image`}
                            />
                        </div>
                        <p className={`textBottom`}>
                            Вдохновляясь этой смелой романтичной мечтой, бренд PLATINA создал коллекцию
                            украшений,
                            которая наполнит вашу жизнь позитивом. Независимо от&nbsp;капризов погоды
                            и&nbsp;даты на&nbsp;календаре!
                        </p>
                        <p className={`textBottom`}>
                            Наш ОКЕАН&nbsp;&mdash; это богатство и&nbsp;великолепие подводной фауны в&nbsp;ярких
                            анималистичных образах. Готовы погрузиться в&nbsp;него прямо сейчас?
                        </p>
                        <img className={`medusaRight`}
                             src={`/storage/img/collections/ocean/medusaRight.png`}
                             alt={`image`}
                             title={`image`}
                        />
                    </div>
                </div>
                <div className={`oceanPanel__three bg`}>
                    <img className={`fauna fauna__one`}
                         src={`/storage/img/collections/ocean/FAUNA-2.png`}
                         alt={`fauna`}
                         title={`fauna`}
                    />
                    <img className={`fauna fauna__two`}
                         src={`/storage/img/collections/ocean/FAUNA-3.png`}
                         alt={`fauna`}
                         title={`fauna`}
                    />
                    <img className={`fauna fauna__three`}
                         src={`/storage/img/collections/ocean/FAUNA-1.png`}
                         alt={`fauna`}
                         title={`fauna`}
                    />
                    <img className={`fauna fauna__four`}
                         src={`/storage/img/collections/ocean/FAUNA-4.png`}
                         alt={`fauna`}
                         title={`fauna`}
                    />
                    <div className={`content`}>
                        <p className={`text`}>
                            Краски океана&nbsp;&mdash; роскошь, созданная Природой! Очарованные
                            их&nbsp;изяществом, украшенные жемчужной &laquo;пеной&raquo;, наши рыбки играют
                            оттенками эмалей, обещая восторг новых открытий.
                        </p>
                    </div>
                    <img className={`fish fish__chain`}
                         src={`/storage/img/collections/ocean/03-3260-00-301-0200-68_цепь_new.png`}
                         alt={`fish`}
                         title={`fish`}
                    />
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('03-3260-00-301-0200-68')}
                    >
                        <img className={`fish fish__one`}
                             src={`/storage/img/collections/ocean/03-3260-00-301-0200-68_подвеска.png`}
                             alt={`fish`}
                             title={`fish`}
                        />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('05-0677-00-301-0200-68')}
                    >
                        <img className={`fish fish__two`}
                             src={`/storage/img/collections/ocean/05-0677-00-301-0200-68.png`}
                             alt={`fish`}
                             title={`fish`}
                        />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4769-00-301-0200-68')}
                    >
                        <img className={`fish fish__three`}
                             src={`/storage/img/collections/ocean/02-4769-00-301-0200-68.png`}
                             alt={`fish`}
                             title={`fish`}
                        />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('01-5488-00-301-0200-68')}
                    >
                        <img className={`fish fish__four`}
                             src={`/storage/img/collections/ocean/01-5488-00-301-0200-68.png`}
                             alt={`fish`}
                             title={`fish`}
                        />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('04-0257-00-301-0200-68')}
                    >
                        <img className={`fish fish__five`}
                             src={`/storage/img/collections/ocean/04-0257-00-301-0200-68.png`}
                             alt={`fish`}
                             title={`fish`}
                        />
                    </div>
                </div>
                <div className={`oceanPanel__four bg`}>
                    <img className={`fauna fauna__one`}
                         src={`/storage/img/collections/ocean/FAUNA-5.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__two`}
                         src={`/storage/img/collections/ocean/FAUNA-6.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__three`}
                         src={`/storage/img/collections/ocean/FAUNA-7.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__four`}
                         src={`/storage/img/collections/ocean/FAUNA-9.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__five`}
                         src={`/storage/img/collections/ocean/FAUNA-8.png`}
                         alt={`fauna`} />
                    <div className={`content`}>
                        <p className={`text`}>
                            В&nbsp;центре внимания яркие &laquo;солнышки&raquo; на&nbsp;глубине моря! Серебряные
                            морские звезды... Стильный талисман для тех, кто в&nbsp;тайне мечтает
                            об&nbsp;исполнении
                            желаний.
                        </p>
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('01-5476-00-203-0200-68')}
                    >
                        <img className={`fish fish__one`}
                             src={`/storage/img/collections/ocean/01-5476-00-203-0200-68.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4757-00-203-0200-68')}
                    >
                        <img className={`fish fish__two`}
                             src={`/storage/img/collections/ocean/02-4757-00-203-0200-68.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('03-3254-00-203-0200-68')}
                    >
                        <img className={`fish fish__three`}
                             src={`/storage/img/collections/ocean/03-3254-00-203-0200-68.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4756-00-203-0200-68')}
                    >
                        <img className={`fish fish__four`}
                             src={`/storage/img/collections/ocean/02-4756-00-203-0200-68.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('05-0672-00-203-0200-68')}
                    >
                        <img className={`fish fish__five`}
                             src={`/storage/img/collections/ocean/05-0672-00-203-0200-68.png`}
                             alt={`fish`} />
                    </div>
                </div>
                <div className={`oceanPanel__five bg`}>
                    <img className={`fauna fauna__one`}
                         src={`/storage/img/collections/ocean/FAUNA-10.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__two`}
                         src={`/storage/img/collections/ocean/FAUNA-11.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__three`}
                         src={`/storage/img/collections/ocean/FAUNA-12.png`}
                         alt={`fauna`} />
                    <div className={`content`}>
                        <p className={`text`}>
                            Медузы... Их&nbsp;повадки поражают воображение. Их&nbsp;грациозная расцветка
                            очаровывает. Их&nbsp;удлинённые серебряные силуэты в&nbsp;сочетании с&nbsp;блеском
                            аметистов дарят настоящий восторг!
                        </p>
                    </div>
                    <img className={`fish fish__chain`}
                         src={`/storage/img/collections/ocean/03-3252-00-203-0200-69_цепь_new.png`}
                         alt={`fish`} />
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('03-3252-00-203-0200-69')}
                    >
                        <img className={`fish fish__one`}
                             src={`/storage/img/collections/ocean/03-3252-00-203-0200-69_подвеска.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4754-00-203-0200-69')}
                    >
                        <img className={`fish fish__two`}
                             src={`/storage/img/collections/ocean/02-4754-00-203-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('04-0255-00-203-0200-69')}
                    >
                        <img className={`fish fish__three`}
                             src={`/storage/img/collections/ocean/04-0255-00-203-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('05-0671-00-203-0200-69')}
                    >
                        <img className={`fish fish__four`}
                             src={`/storage/img/collections/ocean/05-0671-00-203-0200-69.png`}
                             alt={`fish`} />
                    </div>
                </div>
                {/*Коньки*/}
                <div className={`oceanPanel__six bg`}>
                    <img className={`fauna fauna__one`}
                         src={`/storage/img/collections/ocean/FAUNA-13.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__two`}
                         src={`/storage/img/collections/ocean/FAUNA-14.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__three`}
                         src={`/storage/img/collections/ocean/FAUNA-15.png`}
                         alt={`fauna`} />
                    <div className={`content`}>
                        <p className={`text`}>
                            Трогательный символ верности и&nbsp;романтики. Юркие морские коньки выбирают
                            спутника
                            на&nbsp;всю жизнь, и&nbsp;это так трогательно! Их&nbsp;серебряные силуэты найдут
                            местечко в&nbsp;вашем сердце.
                        </p>
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4755-00-203-0200-69')}
                    >
                        <img className={`fish fish__one`}
                             src={`/storage/img/collections/ocean/02-4755-00-203-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4786-00-203-0200-69')}
                    >
                        <img className={`fish fish__two`}
                             src={`/storage/img/collections/ocean/02-4786-00-203-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('04-0256-00-203-0200-69')}
                    >
                        <img className={`fish fish__three`}
                             src={`/storage/img/collections/ocean/04-0256-00-203-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('03-3253-00-203-0200-69')}
                    >
                        <img className={`fish fish__four`}
                             src={`/storage/img/collections/ocean/03-3253-00-203-0200-69.png`}
                             alt={`fish`} />
                    </div>
                </div>
                <div className={`oceanPanel__seven bg`}>
                    <img className={`fauna fauna__one`}
                         src={`/storage/img/collections/ocean/FAUNA-16.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__two`}
                         src={`/storage/img/collections/ocean/FAUNA-17.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__three`}
                         src={`/storage/img/collections/ocean/FAUNA-18.png`}
                         alt={`fauna`} />
                    <div className={`content`}>
                        <p className={`text`}>
                            Осьминог&nbsp;&mdash; символ морской пучины, из&nbsp;которой был сотворён весь мир.
                            В&nbsp;созвучии с&nbsp;голубым топазом его образ олицетворяет гармонию
                            и&nbsp;воплощение самых смелых идей.
                        </p>
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4766-00-201-0200-69')}
                    >
                        <img className={`fish fish__one`}
                             src={`/storage/img/collections/ocean/02-4766-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('01-5487-00-201-0200-69')}
                    >
                        <img className={`fish fish__two`}
                             src={`/storage/img/collections/ocean/01-5487-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('05-0685-00-201-0200-69')}
                    >
                        <img className={`fish fish__three`}
                             src={`/storage/img/collections/ocean/05-0685-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('03-3257-00-201-0200-69')}
                    >
                        <img className={`fish fish__four`}
                             src={`/storage/img/collections/ocean/03-3257-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('07-0245-00-201-0200-69')}
                    >
                        <img className={`fish fish__five`}
                             src={`/storage/img/collections/ocean/07-0245-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                </div>
                <div className={`oceanPanel__eight bg`}>
                    <img className={`fauna fauna__one`}
                         src={`/storage/img/collections/ocean/FAUNA-19.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__two`}
                         src={`/storage/img/collections/ocean/FAUNA-20.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__three`}
                         src={`/storage/img/collections/ocean/FAUNA-21.png`}
                         alt={`fauna`} />
                    <div className={`content`}>
                        <p className={`text`}>
                            Грациозные скаты ассоциируются с&nbsp;беззаботной жизнью и&nbsp;отдыхом.
                            Их&nbsp;изящный
                            подводный полёт нашёл своё отражение в&nbsp;серебряных силуэтах наших украшений.
                        </p>
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4765-00-000-0200-68')}
                    >
                        <img className={`fish fish__one`}
                             src={`/storage/img/collections/ocean/02-4765-00-000-0200-68.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('03-3256-00-000-0200-68')}
                    >
                        <img className={`fish fish__two`}
                             src={`/storage/img/collections/ocean/03-3256-00-000-0200-68.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('01-5480-00-000-0200-68')}
                    >
                        <img className={`fish fish__three`}
                             src={`/storage/img/collections/ocean/01-5480-00-000-0200-68.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('05-0676-00-000-0200-68')}
                    >
                        <img className={`fish fish__four`}
                             src={`/storage/img/collections/ocean/05-0676-00-000-0200-68.png`}
                             alt={`fish`} />
                    </div>
                </div>
                <div className={`oceanPanel__nine bg`}>
                    <img className={`fauna fauna__one`}
                         src={`/storage/img/collections/ocean/FAUNA-22.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__two`}
                         src={`/storage/img/collections/ocean/FAUNA-23.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__three`}
                         src={`/storage/img/collections/ocean/FAUNA-24.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__four`}
                         src={`/storage/img/collections/ocean/FAUNA-25.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__five`}
                         src={`/storage/img/collections/ocean/FAUNA-26.png`}
                         alt={`fauna`} />
                    <div className={`content`}>
                        <p className={`text`}>
                            Неторопливые и&nbsp;плавные, изящные и&nbsp;грациозные... Элегантные серебряные
                            рыбки
                            с&nbsp;крупными голубыми топазами огранки триллион. Обольстительные украшения
                            с&nbsp;лёгким характером.
                        </p>
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('04-0258-00-201-0200-69')}
                    >
                        <img className={`fish fish__one`}
                             src={`/storage/img/collections/ocean/04-0258-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('03-3261-00-201-0200-69')}
                    >
                        <img className={`fish fish__two`}
                             src={`/storage/img/collections/ocean/03-3261-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4770-00-201-0200-69')}
                    >
                        <img className={`fish fish__three`}
                             src={`/storage/img/collections/ocean/02-4770-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('05-0678-00-201-0200-69')}
                    >
                        <img className={`fish fish__four`}
                             src={`/storage/img/collections/ocean/05-0678-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                </div>
                <div className={`oceanPanel__ten bg`}>
                    <img className={`fauna fauna__one`}
                         src={`/storage/img/collections/ocean/FAUNA-50.png`}
                         alt={`fauna`} />
                    <div className={`content`}>
                        <p className={`text`}>
                            Изящные хищницы в&nbsp;красно-фиолетовых тонах! Медузы&nbsp;&mdash; опасные
                            красавицы, движения которых восхищают и&nbsp;завораживают. Не&nbsp;стоит
                            недооценивать их&nbsp;потенциал. Они умеют за&nbsp;себя постоять!
                        </p>
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4777-00-000-0200-69')}
                    >
                        <img className={`fish fish__one`}
                             src={`/storage/img/collections/ocean/02-4777-00-000-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('05-0686-00-000-0200-69')}
                    >
                        <img className={`fish fish__two`}
                             src={`/storage/img/collections/ocean/05-0686-00-000-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('03-3262-00-000-0200-69')}
                    >
                        <img className={`fish fish__three`}
                             src={`/storage/img/collections/ocean/03-3262-00-000-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4787-00-000-0200-69')}
                    >
                        <img className={`fish fish__four`}
                             src={`/storage/img/collections/ocean/02-4787-00-000-0200-69.png`}
                             alt={`fish`} />
                    </div>
                </div>
                <div className={`oceanPanel__eleven bg`}>
                    <img className={`fauna fauna__one`}
                         src={`/storage/img/collections/ocean/FAUNA-27.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__two`}
                         src={`/storage/img/collections/ocean/FAUNA-28.png`}
                         alt={`fauna`} />
                    <div className={`content`}>
                        <p className={`text`}>
                            Эффектный силуэт морских скатов и&nbsp;чувственная глубина голубого
                            топаза&nbsp;&mdash; идеальная метафора для &laquo;подводных&raquo; украшений.
                            С&nbsp;ними вы&nbsp;почувствуете настоящий восторг новых открытий!
                        </p>
                    </div>
                    <img className={`fish fish__chain`}
                         src={`/storage/img/collections/ocean/03-3258-00-201-0200-69_цепь_new.png`}
                         alt={`fish`} />
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('03-3258-00-201-0200-69')}
                    >
                        <img className={`fish fish__one`}
                             src={`/storage/img/collections/ocean/03-3258-00-201-0200-69_подвеска.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('01-5481-00-201-0200-69')}
                    >
                        <img className={`fish fish__two`}
                             src={`/storage/img/collections/ocean/01-5481-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4767-00-201-0200-69')}
                    >
                        <img className={`fish fish__three`}
                             src={`/storage/img/collections/ocean/02-4767-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('05-0684-00-201-0200-69')}
                    >
                        <img className={`fish fish__four`}
                             src={`/storage/img/collections/ocean/05-0684-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                </div>
                <div className={`oceanPanel__twelve bg`}>
                    <img className={`fauna fauna__one`}
                         src={`/storage/img/collections/ocean/FAUNA-51.png`}
                         alt={`fauna`} />
                    <div className={`content`}>
                        <p className={`text`}>
                            Наши драгоценные рыбки&nbsp;&mdash; спутники вашей удачи. Их&nbsp;плавные силуэты,
                            украшенные эмалью и&nbsp;white-топазами, привнесут в&nbsp;образ лёгкую игривость
                            и&nbsp;чувство гармонии.
                        </p>
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4750-00-201-0200-69')}
                    >
                        <img className={`fish fish__one`}
                             src={`/storage/img/collections/ocean/02-4750-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('05-0669-00-201-0200-69')}
                    >
                        <img className={`fish fish__two`}
                             src={`/storage/img/collections/ocean/05-0669-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('03-3250-00-201-0200-69')}
                    >
                        <img className={`fish fish__three`}
                             src={`/storage/img/collections/ocean/03-3250-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4749-00-201-0200-69')}
                    >
                        <img className={`fish fish__four`}
                             src={`/storage/img/collections/ocean/02-4749-00-201-0200-69.png`}
                             alt={`fish`} />
                    </div>
                </div>
                <div className={`oceanPanel__thirteen bg`}>
                    <img className={`fauna fauna__one`}
                         src={`/storage/img/collections/ocean/FAUNA-29.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__two`}
                         src={`/storage/img/collections/ocean/FAUNA-30.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__three`}
                         src={`/storage/img/collections/ocean/FAUNA-31.png`}
                         alt={`fauna`} />
                    <img className={`fauna fauna__four`}
                         src={`/storage/img/collections/ocean/FAUNA-32.png`}
                         alt={`fauna`} />
                    <div className={`content`}>
                        <p className={`text`}>
                            Житель глубин океана&nbsp;&mdash; осьминог. Ему приписываются такие качества, как
                            сила, долголетие и&nbsp;даже вечная жизнь. В&nbsp;голубых оттенках эмали
                            он&nbsp;просто олицетворение элегантности!
                        </p>
                    </div>
                    <img className={`fish fish__chain`}
                         src={`/storage/img/collections/ocean/03-3259-00-000-0200-68_цепь_new.png`}
                         alt={`fish`} />
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('03-3259-00-000-0200-68')}
                    >
                        <img className={`fish fish__one`}
                             src={`/storage/img/collections/ocean/03-3259-00-000-0200-68_подвеска.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('01-5486-00-000-0200-68')}
                    >
                        <img className={`fish fish__two`}
                             src={`/storage/img/collections/ocean/01-5486-00-000-0200-68.png`}
                             alt={`fish`} />
                    </div>
                    <div
                        className={`cp`}
                        // onClick={() => quickViewStore.openModal('02-4768-00-000-0200-68')}
                    >
                        <img className={`fish fish__three`}
                             src={`/storage/img/collections/ocean/02-4768-00-000-0200-68.png`}
                             alt={`fish`} />
                    </div>
                </div>
                <div className={`oceanPanel__fourteen bg`}>
                    <div className={`content`}>
                        <p className={`textTop`}>Сокровища</p>
                        <p className={`textBottom`}>Океана</p>
                        <Link href={`/catalog/okean`} className={`inCatalog`}>
                            Перейти в каталог&nbsp;&nbsp;&nbsp;
                            <img className={`arrow-bottom`}
                                 src={`/storage/img/collections/ocean/arrow.png`} alt="Перейти в каталог" />
                        </Link>
                    </div>
                </div>
            </Slider>
        </div>
    }
}

export default useWithStore(OceanDesktop)
